module.exports = __webpack_public_path__ + "static/my-page-806cf3a4d2bc065d67a94b064eb38cb3.png";